/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Error_Shop_Slug_TakenInputs */

const vi_error_shop_slug_taken = /** @type {(inputs: Error_Shop_Slug_TakenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đường dẫn "${i?.slug}" đã được dùng, hãy chọn đường dẫn khác.`)
};

/**

* @param {Error_Shop_Slug_TakenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_slug_taken = /** @type {((inputs: Error_Shop_Slug_TakenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Slug_TakenInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_slug_taken(inputs)
});